import Swiper, {Pagination} from "swiper";

Swiper.use([Pagination]);

export function initMainSliderWithoutMatches(){

    const swiper = new Swiper('#main_slider_without_matches', {
        loop:false,
        speed: 900,
        preloadImages:false,
        slidesPerView: 1,
        spaceBetween: 20,
        pagination:{
            el: '.slider-pagination-without-matches',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            0: {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 10
            },
            500:{
                slidesPerView: 1,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 40
            }
        }
    });

}